export default __webpack_public_path__ + "static/hero-ai-39e4c09c80cec70cc18dbf800dbf147d.svg";